import { useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useGetWebsiteSettingsQuery, useGetPostsByCategoryQuery } from "../../../app/websiteApiSlice";
import ModernPostsList from "./themes/modern/ModernPostsList";
import ClassicPostsList from "./themes/classic/ClassicPostsList";
import BoldPostsList from "./themes/bold/BoldPostsList";

export default function WebsiteBlogIndex() {
  const { categorySlug } = useParams(); // optional — comes from /blog/category/:categorySlug
  const [page, setPage] = useState(1);
  const { data: settings, isLoading: loadingSettings } = useGetWebsiteSettingsQuery();

  const theme = settings?.theme || "modern";

  if (loadingSettings) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  const props = { settings, categorySlug, page, onPageChange: setPage };

  switch (theme) {
    case "classic":
      return <ClassicPostsList {...props} />;
    case "bold":
      return <BoldPostsList {...props} />;
    case "modern":
    default:
      return <ModernPostsList {...props} />;
  }
}
